const actionMessagesNotLoaded = function () {
  console.error('Action messages not loaded yet.');
};

export const ActionMessageTypes = {
  default: 'default',
  warning: 'warning',
  error: 'error',
};

interface ActionMessagesInterface {
  isLoaded: boolean;
  generateMessage: (args?: {
    message: string;
    undoCallback?: () => void;
    locateUrl?: string;
    duration?: number;
    position?: string;
    type?: keyof typeof ActionMessageTypes;
  }) => void;
}

/** @deprecated prefer `import { useToast } from '@workramp/ui';` */
const ActionMessages: ActionMessagesInterface = {
  isLoaded: false,
  generateMessage: actionMessagesNotLoaded,
};

export default ActionMessages;
